import React, {useEffect} from "react";
import NavBar from "./components/NavBar";
import RoutesDef from "./components/RoutesDef";
import { BrowserRouter as Router, useLocation} from "react-router-dom";
import './index.css';
import { UserProvider } from "./components/UserContext";

// TODO: buggy, creates urls with function as str ???
export const API_URL = 'https://seedsmash-backend.onrender.com';
//export const API_URL = 'http://192.168.1.100:5000';

const ScrollToTop = () => {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};


const App = () => {

  return (
    <div className="App">
      <div class="background-wrapper"></div>
      <UserProvider>
        <Router>
          <ScrollToTop />
          <NavBar/>
          <RoutesDef/>
        </Router>
      </UserProvider>
      
    </div>
  );
};

export default App;